module.exports = __webpack_public_path__ + "static/img/start.06b78808.png";